import type { LanguageKey, LocalizedText } from "@packages/core/language/language.ts";
import { z } from "zod";

export const ReviewThemeSchema = z.enum([
    "ClarityOfExpectations",
    "AccountabilityAndFollowThrough",
    "DecisionQualityAndExecutionDiscipline",
    "GrowthLearningAndSkillDevelopment",
    "FeedbackCulture",
    "IndividualLeadership",
    "CollaborationAndCrossFunctionalEffectiveness",
    "WorkloadAndSustainability",
    "OutcomeOrientation",
    "CommunicationAndTrust",
    "InnovationAndAdaptability",
    "OwnershipAndInitiative"
]);
export type ReviewTheme = z.infer<typeof ReviewThemeSchema>;

export const REVIEW_THEME_NAME_LABELS: Record<ReviewTheme, LocalizedText> = {
    ClarityOfExpectations: { "en-US": "Clarity of Expectations", "fr-CA": "Clarté des attentes" },
    AccountabilityAndFollowThrough: { "en-US": "Accountability and Follow-Through", "fr-CA": "Responsabilité et suivi" },
    DecisionQualityAndExecutionDiscipline: { "en-US": "Decision Quality and Execution Discipline", "fr-CA": "Qualité des décisions et discipline d'exécution" },
    GrowthLearningAndSkillDevelopment: { "en-US": "Growth, Learning and Skill Development", "fr-CA": "Croissance, apprentissage et développement des compétences" },
    FeedbackCulture: { "en-US": "Feedback Culture", "fr-CA": "Culture de feedback" },
    IndividualLeadership: { "en-US": "Individual Leadership", "fr-CA": "Leadership des individus" },
    CollaborationAndCrossFunctionalEffectiveness: { "en-US": "Collaboration and Cross-functional Effectiveness", "fr-CA": "Collaboration et efficacité interfonctionnelle" },
    WorkloadAndSustainability: { "en-US": "Workload and Sustainability", "fr-CA": "Charge de travail et durabilité" },
    OutcomeOrientation: { "en-US": "Outcome Orientation", "fr-CA": "Orientation vers les résultats" },
    CommunicationAndTrust: { "en-US": "Communication and Trust", "fr-CA": "Communication et confiance" },
    InnovationAndAdaptability: { "en-US": "Innovation and Adaptability", "fr-CA": "Innovation et adaptabilité" },
    OwnershipAndInitiative: { "en-US": "Ownership and Initiative", "fr-CA": "Appropriation et initiative" }
};

export function reviewThemeNames(language: LanguageKey): Record<ReviewTheme, string> {
    return Object.fromEntries(ReviewThemeSchema.options.map(theme => [theme, REVIEW_THEME_NAME_LABELS[theme][language]])) as Record<ReviewTheme, string>;
}
